import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    // Pick role from ?intent= if provided, else default buyer
    const search = new URLSearchParams(window.location.search);
    const intent = search.get("intent") === "supplier" ? "supplier" : "buyer";

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/exchange", { session_id: sessionId, role: intent });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch {
        nav("/login?error=google", { replace: true });
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-muted-foreground" data-testid="auth-callback-loading">Signing you in…</div>
    </div>
  );
}
